import { sortBy } from 'lodash';
import backend from '@common/backend';

import { IChunkSnapshotIn } from '../models/Chunks/Chunk';

const BASE = '/chunks';

type GetQueryChunks = {
	lesson_work_id: number;
	search?: string;
	page?: string;
	limit?: string;
};

export type ChunksSort = {
	first_id: number;
	second_id: number;
};

export const getChunks = async (query: GetQueryChunks) =>
	backend.get(`${BASE}/`, { params: query })
		.then((chunks) => sortBy(chunks, 'sort_id'));

export const postChunk = async (data: IChunkSnapshotIn) => backend.post(`${BASE}`, data);

export const postChunks = async (data: IChunkSnapshotIn[]) => backend.post(`${BASE}/bulk`, data);

export const getChunk = async (id: number) => backend.get(`${BASE}/${id}`);

export const updateChunk = async (id: number, data: IChunkSnapshotIn) =>
	backend.put(`${BASE}/${id}`, data);

export const updateChunks = async (data: IChunkSnapshotIn[]) => backend.put(`${BASE}/bulk`, data);

export const updateChunksSort = async (data: ChunksSort[]) =>
	backend.put(`${BASE}/changeSort`, data);

export const deleteChunk = async (id: number) => backend.delete(`${BASE}/${id}`);

export const deleteChunks = async (data: any[]) => backend.delete(`${BASE}/bulk`, data);

export const unzipScorm = async (chunkId: any) => backend.post(`${BASE}/unzip`, { id: chunkId });

export const getStudentChunks = async (query: GetQueryChunks) =>
	backend.get(`${BASE}/student`, { params: query })
		.then((chunks) => sortBy(chunks, 'sort_id'));

export const getIndivStudentChunks = async (query: GetQueryChunks) =>
	backend.get(`${BASE}/indivStudent`, { params: query })
		.then((chunks) => sortBy(chunks, 'sort_id'));
